const bookTitle = (state = "", action) => {
    switch(action.type) {
        case 'bookTitle':
            return action.payload;
        default:
            return state;
    }
}

export default bookTitle;